<header>
    @if (profileRessouce.isLoading()) {
    <kin-skeleton shape="circle" [height]="88" [width]="88" unit="px" />
    <div class="header-info">
        <kin-skeleton [height]="24" [width]="140" unit="px" style="margin-bottom: 12px;" />
        <kin-skeleton [height]="14" [width]="220" unit="px" />
    </div>
    } @else if (profileRessouce.error()) {
    <kin-icon name="warning" />
    <p class="error">{{ 'dashboard.stats.profile_error' | translate }}</p>
    } @else if (profileRessouce.value(); as profile) {
    <img class="client-avatar" [src]="profile.avatar_url" [alt]="profile.name + ' avatar'">
    <div class="header-info">
        <h2>{{ profile.username | upperFirstLetter }}</h2>
        <p>Membre gold premium creator plus ultimate prestige depuis mai 2025</p>
    </div>
    }
</header>
<ul class="stats-container">
    <li>
        <kin-icon name="upload" />
        <div class="count">{{ profileService.pendingContentCount() }}</div>
        <p class="label">{{ 'dashboard.stats.pending_contents' | translate }}</p>
    </li>
    <li>
        <kin-icon name="instruction" />
        <div class="count">{{ profileService.inAppContentCount() }}</div>
        <p class="label">{{ 'dashboard.stats.in_app_contents' | translate }}</p>
    </li>
    <li>
        <kin-icon name="completed_flag" />
        <div class="count">{{ profileService.inAppSessionsCount() }}</div>
        <p class="label">{{ 'dashboard.stats.in_app_sessions' | translate }}</p>
    </li>
</ul>